// extracted by mini-css-extract-plugin
export var notificationHost = "_ck-0";